export const APP_ID = "emblem-health-web";
export const APP_NAME = "Emblem Health";
